import { Paper, Button, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Paper)({
  maxWidth: '700px',
  width: '100%',
  padding: '30px 50px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 4px 0 rgba(0,0,0,0.08), 0 0 8px 0 rgba(0,0,0,0.10)',
  borderRadius: '0',

  [theme.breakpoints.down('sm')]: {
    maxWidth: '400px',
    padding: '20px 10px',
  },
});

export const Wrapper = styled.form({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '10px 0 20px',
  '& > div': {
    width: '100%',
  },

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    '& > div': {
      maxWidth: '400px',
      marginBottom: '10px',
    },
  },
});

export const Required = styled(Typography)({
  margin: '10px 3px auto auto',
  minHeight: '24px',
  fontSize: '12px',

  [theme.breakpoints.down('sm')]: {
    margin: '15px auto 0 3px',
  },
});

export const StyledButton = styled(Button)({
  maxWidth: '150px',
  width: '100%',
  margin: '15px 3px 13px auto',
  boxShadow: 'none',
  borderRadius:'100vmax',
  backgroundColor:'#ffd5ad',
  color:'#000066',
  '&:hover': {
    transition: 'all .5s',
    background: '#f2ba91',
  },

  [theme.breakpoints.down('sm')]: {
    maxWidth: '400px',
    width: '100%',
    margin: '25px 3px 0',
  },
});
